<template>
    <div>
        
        <BreadCrumbs v-bind:bcrumbs="bcrumbs" />
        <PageTitle v-bind:title="title" v-bind:admin="true" />

        <!-- Add Item form -->       
        <button type="button" class="btn btn-primary" @click.prevent="showAddForm">+ Новая Глава</button>
        <div class="modal fade" id="addForm" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">New item</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- <form> -->
                        <div class="form-group">
                            <label for="name" class="col-form-label">Name:</label>
                            <input type="text" class="form-control" id="name" name="name" v-model="name">
                            <div class="alert alert-danger" v-if="errors.validationAdd && errors.validationAdd.name">
                                {{ errors.validationAdd.name[0] }}
                            </div>
                        </div>
                        <!-- </form> -->
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent="cancelAdding">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="addRecord">Add</button>
                    </div>
                    <div class="alert alert-danger" v-if="errors.add">
                        {{ errors.add }}
                    </div>
                </div>
            </div>
        </div>
        <!-- END of Add Item form -->

        <!-- Модальное окно для подтверждения удаления -->
        <ModalOkCancel v-bind:data="ModalOkCancelData" v-on:mrok="deleteRecord2"/>

        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>
        <Loader v-if="loading" />
        <div v-else-if="data.length">
            <div class="alert alert-danger" v-if="errors.delete">
                {{ errors.delete }}
            </div>
            <div class="alert alert-danger" v-if="errors.any">
                {{ errors.any }}
            </div>
            <table class="table mt-4 bg-light shadow p-3 mb-5 rounded">
                <thead>
                    <tr>
                        <th></th>
                        <th>
                            <p>Наименование</p>
                            <input class="form-control" type="text" name="name" id="name" v-model="f_name">                          
                        </th>
                        <th>
                            <p>Состояние</p>
                            <select class="form-select form-select-sm form-control" name="chapterstate" id="chapterstate" v-model="f_chapterstate_id">
                                <option value="-1" :selected="true">Все</option>
                                <option v-for="item in chapterstates" :key="item.id" :value="item.id">{{ item.name }}</option>
                            </select>
                        </th>
                        <!-- <th></th>
                        <th></th>
                        <th></th> -->
                        <th></th>
                        <th class="align-top">
                            <p>Сортировка</p>
                            <!-- <input visible="false" class="form-control" type="text" name="name" id="name" v-model="f_name">                                                       -->
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in filteredData" :key="item.id">
                        <td>{{ item.id }}</td>
                        <!-- <td>{{ item.name }}</td> -->
                        <td>
                            <router-link :to="{ name: 'adminChapter_show', params: { id: item.id } }">{{ item.name }}</router-link>
                            <abbr v-if="item.is_final" title="Эта глава - финальная, будет доступна после завершения всех остальных" class="badge badge-info">fin</abbr>
                        </td>
                        <td>{{ item.chapterstate_name }}</td>
                        <!-- <td>
                            <form @submit.prevent="deleteRecord(item.id)">
                                <button type="submit" class="btn btn-danger">Удалить</button>
                            </form>
                        </td>
                        <td>
                            <router-link :to="{ name: 'adminChapter_edit', params: { id: item.id } }">Ред.главу {{item.id}}</router-link>
                        </td>
                        <td>
                            <router-link :to="{ name: 'adminChapter_questions', params: { chapter_id: item.id } }">Список вопросов {{item.id}}</router-link>
                        </td> -->
                        <td>
                            <ul class="nav nav-pills">
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">&#9776;</a>
                                    <div class="dropdown-menu">
                                        <router-link class="alert alert-primary dropdown-item" :to="{ name: 'adminChapter_edit', params: { id: item.id } }">Редактировать главу</router-link>
                                        <div class="dropdown-divider"></div>
                                        <router-link class="dropdown-item" :to="{ name: 'adminChapter_questions', params: { chapter_id: item.id } }">Список вопросов</router-link>
                                        <div class="dropdown-divider"></div>
                                        <!-- <a class="dropdown-item" href="#">Action</a> -->
                                        <button type="button" class="btn dropdown-item" @click.prevent="publicChapter(item.id)">Включить Главу в Курс</button>
                                        <button type="button" class="btn dropdown-item" @click.prevent="unpublicChapter(item.id)">Вернуть Главу в Черновики</button>
                                        <div class="dropdown-divider"></div>
                                        <button type="button" class="btn dropdown-item" @click.prevent="setFinalChapter(item.id)">Сделать Главу финальной</button>
                                        <button type="button" class="btn dropdown-item" @click.prevent="unsetFinalChapter(item.id)">Сделать Главу НЕ финальной</button>
                                        <!-- <a class="dropdown-item" href="#">Separated link</a> -->
                                        <div class="dropdown-divider"></div>
                                        <button type="button" class="alert alert-danger dropdown-item" @click.prevent="askToDeleteRecord(item)">УДАЛИТЬ</button>
                                    </div>
                                </li>
                            </ul>
                        </td>
                        <td>{{ item.orderby }}</td>


                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import jQuery from 'jquery'
import PageTitle from '@/components/PageTitle'
import BreadCrumbs from '@/components/BreadCrumbs'
import ModalOkCancel from '@/components/ModalOkCancel'
export default {
    data() {
        return {
            loading: true,
            title: 'Список Глав',
            data: [],
            id: 0,
            name: '',
            errors: {load: '', add: '', delete: '', edit: '', validationAdd: {}, validationEdit: {}, any: ''},
            ModalOkCancelData: { id: 0, caption: '', message: '', show: false, style: '', okCaption: 'Удалить!' },
            bcrumbs: [],

            // для фильтрации:
            f_chapterstate_id: -1,
            f_name: '',
        }
    },
    computed: {
        filteredData() {
            return this.data.filter(rec => 
                (
                    rec.name.toLowerCase().includes(this.f_name.toLowerCase())
                    &&
                    ((rec.chapterstate_id == this.f_chapterstate_id) || (this.f_chapterstate_id == -1))

                )
            )
        }
    },
   async mounted() {
       this.loadRecords(this.$route.params.course_id)
    },
    methods: {
        clearErrors() {
            this.errors.load = '';
            this.errors.add = '';
            this.errors.delete = '';
            this.errors.edit = '';
            this.errors.any = '';
        },
        async loadRecords(course_id) {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('admin/courses/'+course_id+'/chapters')
                this.data = response.data.chapters
                this.chapterstates = response.data.chapterstates
                this.bcrumbs = response.data.bcrumbs
                //console.log(this.data);
                this.loading = false
            }
            catch (e) {
                this.errors.load = 'Ошибка при загрузке данных'
            }
        },
        showAddForm() {
            this.name = ''
            this.errors.validationAdd = {}
            // this.errors.add = ''
            this.clearErrors();
            jQuery('#addForm').modal('show')
        },
        cancelAdding() {
            this.name = ''
            jQuery('#addForm').modal('hide')
        },
        //
        // Add new record.
        //
        async addRecord() {
            var course_id = this.$route.params.course_id
            this.errors.validationAdd = {}
            // this.errors.add = ''
            this.clearErrors();
            try {
                let response = await axios.post('admin/courses/'+course_id+'/chapters', {name: this.name})
                if (response.status == 200) {
                    this.name = ''
                    this.loadRecords(course_id)
                    jQuery('#addForm').modal('hide')
                }
            }
            catch(e) {
                if (e.response.status == 422) {
                    this.errors.validationAdd = e.response.data.errors
                }               
                else if (e.response.status == 520) {
                    this.errors.add = "Ошибка при создании записи."
                }
                else {
                    this.errors.add = "Неизвестная ошибка при создании записи."
                }
            }
        },
        //
        // Delete record.
        //
        /*
        async deleteRecord(id) {
            this.errors.delete = ''
            try {
                let response = await axios.delete('admin/chapters/'+id)
                if (response.status == 200) {
                    // удаление эл-та из списка "на клиенте":
                    let index = this.data.findIndex(tmpdata => tmpdata.id == id)
                    this.data.splice(index, 1)            
                }
            }
            catch (e) {
                if (e.response.status == 520) {
                    console.log(e.response);
                    console.log(e.response.data);
                    console.log(e.response.data.error);
                    this.errors.delete = e.response.data.error
                }
                else {
                    this.errors.delete = 'Неизвестная ошибка при удалении.'
                }
            } 
        },
        */


        //
        // Показываем MessageBox с подтверждением удаления Главы.
        //
        askToDeleteRecord(item) {
            this.clearErrors();
            this.ModalOkCancelData.id = item.id
            this.ModalOkCancelData.style = 'danger'
            this.ModalOkCancelData.caption = 'Внимание!'
            this.ModalOkCancelData.message = 'Вы действительно хотите удалить Главу <strong>"' + item.name + '"</strong>?'
            this.ModalOkCancelData.show = true;
        },

        //
        // Удалить Главу.
        //
        async deleteRecord2() {
            this.clearErrors();
            var id = arguments[0];
            if (id > 0) {
                try {
                    let response = await axios.delete('admin/chapters/'+id)
                    if (response.status == 200) {
                        // удаление эл-та из списка "на клиенте":
                        let index = this.data.findIndex(tmpdata => tmpdata.id == id)
                        this.data.splice(index, 1)            
                    }
                }
                catch (e) {
                    if (e.response.status == 520) {
                        /*
                        console.log(e.response);
                        console.log(e.response.data);
                        console.log(e.response.data.error);
                        */
                        this.errors.delete = e.response.data.error
                    }
                    else {
                        this.errors.delete = 'Неизвестная ошибка при удалении.'
                    }
                } 
            }
        },

        //
        // Опубликовать Главу (включить её в Курс).
        //
        async publicChapter(id) {
            var course_id = this.$route.params.course_id
            // this.errors.any = ''
            this.clearErrors();
            try {
                let response = await axios.post('admin/chapters/'+id+'/action/public')
                if (response.status == 200) {
                    this.loadRecords(course_id)
                }
            }
            catch(e) {
                if (e.response.status == 520) {
                    this.errors.any = e.response.data.error
                }
                else {
                    this.errors.any = "Ошибка при публикации Главы."
                }
            }
        },


        //
        // Снять Главу с публикации (вернуть её в Черновики).
        //
        async unpublicChapter(id) {
            var course_id = this.$route.params.course_id
            // this.errors.any = ''
            this.clearErrors();
            try {
                let response = await axios.post('admin/chapters/'+id+'/action/unpublic')
                if (response.status == 200) {
                    this.loadRecords(course_id)
                }
            }
            catch(e) {
                if (e.response.status == 520) {
                    this.errors.any = e.response.data.error
                }
                else {
                    this.errors.any = "Ошибка при снятии Главы с публикации."
                }
            }
        },


        //
        // Сделать Главу "финальной".
        //
        async setFinalChapter(id) {
            var course_id = this.$route.params.course_id
            // this.errors.any = ''
            this.clearErrors();
            try {
                let response = await axios.post('admin/chapters/'+id+'/action/set_final')
                if (response.status == 200) {
                    this.loadRecords(course_id)
                }
            }
            catch(e) {
                if (e.response.status == 520) {
                    this.errors.any = e.response.data.error
                }
                else {
                    this.errors.any = "Ошибка при редактировании (set_final)."
                }
            }
        },

        //
        // Сделать Главу НЕ "финальной".
        //
        async unsetFinalChapter(id) {
            var course_id = this.$route.params.course_id
            // this.errors.any = ''
            this.clearErrors();
            try {
                let response = await axios.post('admin/chapters/'+id+'/action/unset_final')
                if (response.status == 200) {
                    this.loadRecords(course_id)
                }
            }
            catch(e) {
                if (e.response.status == 520) {
                    this.errors.any = e.response.data.error
                }
                else {
                    this.errors.any = "Ошибка при редактировании (unset_final)."
                }
            }
        },


    },
    components: {
        Loader,
        PageTitle,
        ModalOkCancel,
        BreadCrumbs,
    }
}
</script>

<style scoped>
</style>